import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const umami = defineConnector({
  identifier: "umami",
  name: "Umami",
  tagLine: "Privacy-focused web analytics",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://api\\.umami\\.is/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Enter your Umami instance",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "api.umami.is",
          target: { kind: "configuration", field: "domain" },
          helperText:
            "Use api.umami.is for Umami Cloud, or your self-hosted domain.",
        },
      ],
    },
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Umami Cloud, go to **Settings › API Keys** to generate a key. For self-hosted, use the login endpoint to get a bearer token. See the [API docs](https://umami.is/docs/api) for details.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/auth/verify`,
  },
});
